import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { SubCourseFormValues } from "src/models/SubCourse.model";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import { handleValidNumber } from "src/utils/validations/numberInput";

type Props = {
  formikProps: FormikProps<SubCourseFormValues>;
  onClose: () => void;
  formType: "Add" | "Update";
};

const getDaysOption = (days: string) => {
  let dayslength = parseInt(days)
  let options: any = []
  for (let i = 1; i <= dayslength; i++) {
    options = [...options,
    {
      label: `${i} Day`,
      value: `${i} Day`
    },
    ]
  }
  return options
}

const SubCourseForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">{formType} Sub-Course</div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            placeholder="Enter Name"
            name="name"
            value={values.name}
            onChange={(e) => {
              setFieldValue("name", e.target.value);
            }}
            required
            label="Name"
            onBlur={handleBlur}
          />
        </div>
        {values?.PlanDetails?.map((el: any, ind: any) => {
          return (
            <div className="grid grid-cols-4  gap-4">
              <div>
                <ATMTextField
                  required
                  placeholder="Enter Plan"
                  name={`PlanDetails.${[ind]}.plan`}
                  value={el?.plan?.label}
                  onChange={(e) => setFieldValue('hello', e.target.value)}
                  label="Plan"
                  onBlur={handleBlur}
                  disabled
                />
              </div>
              <div>
                <ATMTextField
                  required
                  placeholder="Enter Fees"
                  name={`PlanDetails.${[ind]}.fees`}
                  value={el?.fees}
                  onChange={(e) => {
                    handleValidNumber(e) &&
                      setFieldValue(
                        `PlanDetails.${[ind]}.fees`,
                        e.target.value
                      );
                  }}
                  label="Fees"
                  onBlur={handleBlur}
                />
              </div>
              {/* Start Day */}
              <div className="">
                <ATMSelect
                  required
                  name={`PlanDetails.${[ind]}.startDay`}
                  value={el?.startDay}
                  onChange={(newValue) =>
                    setFieldValue(`PlanDetails.${[ind]}.startDay`, newValue)
                  }
                  onBlur={handleBlur}
                  label="Start Day"
                  placeholder="Select Start Day"
                  options={getDaysOption(el?.noOfDays)}
                />
              </div>
              {/* End Day */}
              <div className="">
                <ATMSelect
                  required
                  name={`PlanDetails.${[ind]}.endDay`}
                  value={el?.endDay}
                  onChange={(newValue) =>
                    setFieldValue(`PlanDetails.${[ind]}.endDay`, newValue)
                  }
                  onBlur={handleBlur}
                  label="End Day"
                  placeholder="Select End Day"
                  options={getDaysOption(el?.noOfDays)}
                />
              </div>
            </div>
          );
        })}
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default SubCourseForm;
